import React from 'react'
import PropTypes from 'prop-types'

const Footer = props => (
  <footer id="footer" style={props.timeout ? { display: 'none' } : {}}>
    <p className="copyright">
       Joseph Fay 2022 - Design by HTML5 UP. Built with:{' '}
      <a href="https://www.gatsbyjs.org/">React/Gatsby.js</a>.
    </p>
    <br />
    <ul className="icons">
      <li>
        <a
          href="https://www.linkedin.com/in/jmfay/"
          className="icon fa-linkedin"
          target="_blank"
          rel="noreferrer"
        >
          <span className="label">LinkedIn</span>
        </a>
      </li>
      <li>
        <a
          href="https://github.com/jmfay"
          className="icon fa-github"
          target="_blank"
          rel="noreferrer"
        >
          <span className="label">GitHub</span>
        </a>
      </li>
      <li>
        <a className="icon fa-envelope" href="mailto:jmfay33@gmail.com">
          <span className="label">E-Mail</span>
        </a>
      </li>
    </ul>
  </footer>
)

Footer.propTypes = {
  timeout: PropTypes.bool,
}

export default Footer
